import "./OvenCleaningAndWashingRiyadh.module.css";
import Header from "@/reusable_sections/Header";
import OvenLandingHero from "./sections/OvenLandingHero";
import OvenCleaningServiceDetails from "./sections/OvenCleaningServiceDetails";
import Footer from "@/reusable_sections/Footer";
export default function OvenCleaningAndWashingRiyadhPage() {
  return <div>
      <Header />
      <OvenLandingHero />
      <OvenCleaningServiceDetails />
      <Footer />
    </div>;
}